
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Award, Star, Trophy, Medal } from 'lucide-react';

interface BadgeProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  unlocked: boolean;
}

interface BadgeCardProps {
  totalSOSEvents: number;
}

const BadgeCard = ({ totalSOSEvents }: BadgeCardProps) => {
  // Define badges based on number of SOS events (cravings) overcome
  const badges: BadgeProps[] = [
    {
      title: "First Step",
      description: "Beat your first craving",
      icon: <Star className="h-5 w-5 text-yellow-500" />,
      unlocked: totalSOSEvents >= 1
    },
    {
      title: "Determined",
      description: "Beat 5 cravings",
      icon: <Medal className="h-5 w-5 text-blue-500" />,
      unlocked: totalSOSEvents >= 5
    },
    {
      title: "Warrior",
      description: "Beat 10 cravings",
      icon: <Award className="h-5 w-5 text-purple-500" />,
      unlocked: totalSOSEvents >= 10
    },
    {
      title: "Champion",
      description: "Beat 25 cravings",
      icon: <Trophy className="h-5 w-5 text-amber-500" />,
      unlocked: totalSOSEvents >= 25
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Badges</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {badges.map((badge, index) => (
            <div 
              key={index} 
              className={`flex flex-col items-center p-3 rounded-lg border ${
                badge.unlocked 
                  ? 'bg-cream border-sage/50' 
                  : 'bg-gray-100 border-gray-200 opacity-50'
              }`}
            >
              <div className="mb-2">
                {badge.icon}
              </div>
              <h3 className="text-sm font-semibold">{badge.title}</h3>
              <p className="text-xs text-center text-gray-500 mt-1">{badge.description}</p>
              {badge.unlocked ? (
                <Badge variant="default" className="bg-sage text-xs mt-2">Unlocked</Badge>
              ) : (
                <Badge variant="outline" className="text-xs mt-2">Locked</Badge>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BadgeCard;
